import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { InProgressEntityCredentialApplicationFields } from 'src/app/credentialing/credentialing-home/inprogress_entity_credential-application.fields';
import { CustomView } from 'src/app/shared/components/odata-filter/models/custom-view';
import { FilterOperatorType } from 'src/app/shared/components/odata-filter/models/filter-operator-type';
import { OPERATORS } from 'src/app/shared/components/odata-filter/models/operators';
import { SavedFilter } from 'src/app/shared/components/odata-filter/models/saved-filter';
import { SelectedFilter } from 'src/app/shared/components/odata-filter/models/selected-filter';
import { SearchValueType } from 'src/app/shared/components/odata-filter/models/search-value-type';
import { ViewContext } from 'src/app/shared/components/odata-filter/models/view-context';
import { ApiVersions } from 'src/app/shared/services/api-version';
import { BaseODataService } from 'src/app/shared/services/base-odata.service';
import { last30Days } from 'src/app/shared/utils/date-utils';
import { RegularFilterModel } from 'src/app/shared/odata-filter-models/regular-filter-model';
import { InProgressApplicationRow } from './in-progress-application-row.model';

@Injectable()
export class InProgressApplicationsService extends BaseODataService {
  public readonly recentlyUpdatedApplications = new Subject<InProgressApplicationRow[]>();

  private readonly updatedOnFilterModel = new RegularFilterModel(
    'Updated On',
    InProgressEntityCredentialApplicationFields.credentialApplicationUpdatedOn,
    SearchValueType.Date
  );

  constructor() {
    super();

    this._baseUrl = 'inProgressEntityCredentialApplication';
  }

  getRecentlyUpdatedApplications(view: CustomView) {
    let filters = SavedFilter.parseToAppliedFilters(
      view.filters,
      ViewContext.InProgressEntityCredentialApplications
    ).concat(this.generateFilters());

    let queryParams = {
      select: [
        InProgressEntityCredentialApplicationFields.id,
        InProgressEntityCredentialApplicationFields.entityId,
        InProgressEntityCredentialApplicationFields.entityType,
        InProgressEntityCredentialApplicationFields.name,
        InProgressEntityCredentialApplicationFields.credentialName,
        InProgressEntityCredentialApplicationFields.applicationStatusLabel,
        InProgressEntityCredentialApplicationFields.credentialApplicationUpdatedOn
      ],
      filter: this.buildFilter([...filters]),
      orderBy: [
        `${InProgressEntityCredentialApplicationFields.credentialApplicationUpdatedOn} desc`
      ],
      count: false
    };

    this.getODataResult(this.allResultsFilterUrl, queryParams, ApiVersions.unversioned)
      .pipe(
        map((response) => {
          if (response && response.value) {
            return response.value.map((v) => new InProgressApplicationRow(v));
          } else {
            return [];
          }
        })
      )
      .subscribe((result) => this.recentlyUpdatedApplications.next(result));
  }

  private generateFilters() {
    return [
      new SelectedFilter({
        filter: this.updatedOnFilterModel,
        filterOperator: OPERATORS.Date.operators.find(
          (op) => op.displayOperator == FilterOperatorType.gt
        ),
        searchValue: last30Days()
      })
    ];
  }
}
